Vendd.Scripts.load(function () {

    var $form = $('.x-account-create-user-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        "firstName": $('input[name="firstName"]').val(),
        "lastName": $('input[name="lastName"]').val(),
        "email": $('input[name="email"]').val(),
        "username": $('input[name="username"]').val(),
        "redirectUrl": $form.data('redirect') || ""
    };

    var useEmailAsLoginName = $form.data('useemailasloginname').toString().toLowerCase() === 'true';

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.success && response.code === "Registration_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-content', $form).hide();
            
            $('.js-success', $form).show();

            envelope.message.data.isSupportUser = $('#supportUser').val().toLowerCase() === 'true';
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginRedirect(envelope));
        } else {
            if (response.code === 'Registration_EmailExists') {
                $('.js-error', $form).hide();
                $('.js-exists', $form).show();

            } else {
                $('.js-exists', $form).hide();
                $('.js-error', $form).show();

                $('.js-error', $form).show();
            };
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-exists-error', $form).hide();
        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        $('input:not([type="checkbox"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.CreateUser(
            formData.firstName,
            formData.lastName,
            formData.email,
            formData.username,
            formData.redirectUrl));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="username"]', $form).val("");

        rf.reset();
    };


    var valOpts = {
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        }
    };

    if (!useEmailAsLoginName) {
        valOpts.username = {
            required: 'username-required'
        };
    }

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val2 = rf.validate();

        if (val2) {
            form.submit();
        }
    });

    $form.on('keyup', 'input[name]', function (e) {

        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');


        rf.validate(fieldName);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.CreateUserSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.User.Messages.CreateUserFailure, form, form.onFailure);
});